const formatter = new Intl.DateTimeFormat('en-US', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  timeZone: 'UTC',
});

/**
 * Format a date as "MM/DD/YYYY" in UTC.
 *
 * formatMMDDYYYYUtc('2026-05-14') // → "05/14/2026"
 */
export const formatMMDDYYYYUtc = (
  date: Date | string | undefined | null,
): string => {
  if (date == null) {
    return '';
  }
  const parsed = new Date(date);
  return isNaN(parsed.getTime()) ? '' : formatter.format(parsed);
};
